
























































import navdraw from "./components/navdraw.vue";
import { Component, Vue, Ref, Watch } from "vue-property-decorator";
@Component({
  name: "App",
  components: {
    navdraw
  }
})
export default class App extends Vue {
  get drawer() {
    return this.$store.getters["getNavbarState"];
  }
  set drawer(val) {
    this.$store.commit("setDrawer", val);
  }
}
